import { render, staticRenderFns } from "./adviserParenting.vue?vue&type=template&id=525148d4&scoped=true&lang=html&"
import script from "./adviserParenting.vue?vue&type=script&lang=js&"
export * from "./adviserParenting.vue?vue&type=script&lang=js&"
import style0 from "./adviserParenting.vue?vue&type=style&index=0&id=525148d4&lang=scss&scoped=true&"
import style1 from "./adviserParenting.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525148d4",
  null
  
)

export default component.exports